import {
  init as amplitudeInit,
  track as amplitudeTrack,
  setUserId as amplitudeSetUserId,
  reset as amplitudeReset,
} from "@amplitude/analytics-browser";

const NEXT_PUBLIC_AMPLITUDE_API_KEY =
  process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY || "";

/**
 * Initializes the Amplitude SDK.
 * This should be called once when the application starts.
 * @param userId The user ID to associate with the events.
 */
export const init = (userId?: string) => {
  if (NEXT_PUBLIC_AMPLITUDE_API_KEY) {
    amplitudeInit(NEXT_PUBLIC_AMPLITUDE_API_KEY, userId, {
      defaultTracking: true,
      autocapture: {
        networkTracking: true,
      },
    });
  } else {
    console.warn("Amplitude API Key is not configured. Tracking is disabled.");
  }
};

/**
 * Tracks an event using Amplitude.
 *
 * @param eventName The name of the event to track.
 * @param eventProperties An object containing additional data for the event.
 */
export const track = (
  eventName: string,
  eventProperties?: Record<string, any>,
) => {
  console.log("🚀 ~ track ~ eventName:", eventName, eventProperties);
  amplitudeTrack(eventName, eventProperties);
};

/**
 * Sets the user ID for the current session.
 * @param userId The user ID to associate with the events.
 */
export const setUserId = (userId: string) => {
  amplitudeSetUserId(userId);
};

/**
 * Clears the user ID for the current session (on logout).
 */
export const clearUserId = () => {
  amplitudeSetUserId(undefined);
  amplitudeReset();
};

export const getSearchParams = (): Record<string, string> => {
  try {
    const params = new URLSearchParams(window.location.search);
    return Object.fromEntries(params.entries());
  } catch (error) {
    console.error("🚀 ~ getParams ~ error:", error)
    return {};
  }
}